import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./Schedule.css";
import API from "../utils/axiosInstance";

const ClassCalendar = () => {
  const [date, setDate] = useState(new Date());
  const [assignedClasses, setAssignedClasses] = useState([]);

  useEffect(() => {
  const fetchAssignedClasses = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;

      if (!userId) return;

      const { data: schedules } = await API.get(`/schedules/user/${userId}`);
      console.log("User schedules:", schedules);
      setAssignedClasses(schedules);
    } catch (err) {
      console.error("❌ Error fetching user schedules:", err.response?.data || err.message);
    }
  };

  fetchAssignedClasses();
}, []);


  // Check if a date has a class
  const getClassForDate = (date) => {
    const formatted = date.toDateString();
    return assignedClasses.find(cls => new Date(cls.createdAt).toDateString() === formatted);
  };

  return (
    <div className="calendar-container">
      <Calendar
        onChange={setDate}
        value={date}
        tileContent={({ date }) =>
          getClassForDate(date) ? <span className="dot"></span> : null
        }
      />
    </div>
  );
};

export default ClassCalendar;
